import { render, staticRenderFns } from "./BookingPriceSummary.vue?vue&type=template&id=158e0f42&scoped=true&"
import script from "./BookingPriceSummary.vue?vue&type=script&lang=js&"
export * from "./BookingPriceSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingPriceSummary.vue?vue&type=style&index=0&id=158e0f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e0f42",
  null
  
)

export default component.exports